import React from 'react';
import {Popup} from 'react-map-gl';

const LocationPopup = ({info, longitude, latitude, setCurrentTooltip})=>{
  const style = {
    whiteSpace: "pre-wrap",
    maxHeight: "400px",
    maxWidth: "400px",
    overflow: "auto"
  }
  return(<>
    { info && <Popup
        tipSize={5}
        anchor="top"
        longitude={longitude}
        latitude={latitude}
        closeOnClick={false}
        onClose={() => setCurrentTooltip(null)}
      >
        <div style={style}>{JSON.stringify(info, null, 2)}</div>
      </Popup>
    }
  </>
  )
}

export default LocationPopup